import { cn } from '@/lib/utils';
import Facebook from '@/assets/svg/facebook.svg?react';
import Instagram from '@/assets/svg/instagram.svg?react';
import Whatsapp from '@/assets/svg/whatsapp.svg?react';

interface ChannelCardProps {
  chatCount: number;
  trend?: 'up' | 'down';
  trendValue?: string;
  variant?: 'instagram' | 'whatsapp' | 'facebook';
  /** Shows a “Coming soon” badge (e.g. WhatsApp). */
  comingSoon?: boolean;
  className?: string;
}

function ChannelCard({
  chatCount,
  // trend = 'up',
  // trendValue,
  variant = 'whatsapp',
  comingSoon = false,
  className,
}: ChannelCardProps) {
  return (
    <div
      className={cn(
        'relative flex flex-col justify-between h-32 w-full max-w-2xl rounded-md p-4 bg-green-50/25 border border-green-200',
        { 'border-blue-100 bg-blue-50/25': variant === 'facebook' },
        { 'border-purple-100 bg-purple-50/25': variant === 'instagram' },
        comingSoon && 'opacity-90',
        className
      )}
    >
      {comingSoon && (
        <span className="absolute right-2 top-2 rounded-full bg-gray-900 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white">
          Coming soon
        </span>
      )}
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <div
            className={cn(
              'rounded-full bg-primary w-2 h-2',
              { 'bg-blue-600': variant === 'facebook' },
              { 'bg-purple-600': variant === 'instagram' }
            )}
          />
          <h5 className="text-sm capitalize">{variant}</h5>
        </div>
        {variant === 'whatsapp' && <Whatsapp className="size-8" />}
        {variant === 'instagram' && <Instagram className="size-8" />}
        {variant === 'facebook' && <Facebook className="size-8" />}
      </div>
      <div className="flex justify-between items-center">
        <p className="font-semibold text-lg md:text-xl">{chatCount} chats</p>
        {/* <p
          className={cn(
            'bg-primary/15 text-primary text-xs px-1.5 py-0.5 rounded-sm',
            {
              'bg-destructive/15 text-destructive': trend === 'down',
            }
          )}
        >
          {trend === 'down' && '-'}
          {trendValue}
        </p> */}
      </div>
    </div>
  );
}

export { ChannelCard };
